import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ReactComponent as HardwareIcClose24px } from '../../assets/icons/navigation/ic_close_24px.svg';
import { MotifIconButton } from '../button/icon-button/icon-button';

const defaultIcons = {
  close: <HardwareIcClose24px />
};

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {() => void} [onClose]
 * @prop {string} [className]
 * @prop {boolean} [openFromLeft]
 * @prop {boolean} [show]
 * @prop {{close: React.ReactNode}} [icons]
 * @prop {'default' | 'alt'} [variant]
 * @prop {string} [title]
 * @prop {{}} [closeButtonProps]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifMenu = (props) => {
  const {
    children,
    icons: userIcons = {},
    onClose = null,
    className = '',
    openFromLeft = false,
    show = false,
    variant = 'default',
    title = '',
    closeButtonProps = {},
    ...other
  } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const overlayClasses = classNames({
    'motif-menu-overlay': true,
    'motif-menu-overlay-open': show
  });

  const classes = classNames({
    'motif-menu': true,
    'motif-menu-alt': variant === 'alt',
    'motif-menu-open': show,
    'motif-menu-open-from-left': openFromLeft,
    [className]: true
  });

  const closeButton = useMemo(
    () => (
      <MotifIconButton
        aria-label={title ? '' : 'Close Main Menu'}
        type="button"
        onClick={onClose}
        {...closeButtonProps}
      >
        {icons.close}
      </MotifIconButton>
    ),
    [onClose]
  );

  return (
    <div className={overlayClasses} data-motif-menu>
      <div className={classes} {...other}>
        {show && (
          <div>
            <div className="motif-menu-header">
              {title && <h3 className="motif-menu-header-title">{title}</h3>}
              {closeButton}
            </div>
            <nav className="motif-menu-nav">
              <ul className="motif-menu-list">{children}</ul>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

MotifMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icons: PropTypes.shape({
    close: PropTypes.node
  }),
  onClose: PropTypes.func,
  show: PropTypes.bool,
  openFromLeft: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'alt']),
  title: PropTypes.string,
  closeButtonProps: PropTypes.instanceOf(Object)
};

export { MotifMenu };
